export default "__VITE_ASSET__DjqskTKE__"